export enum ProgressNavItemsEnum {
  BG,
  HG,
  UMZUG,
  KDU,
  KONTOAUSZUEGE,
  EINKOMMEN,
  ABSETZUNGEN,
  WEITERE_AENDERUNGEN,
  ZUSAMMENFASSUNG
}
